
/**
 * Wealthica v2 API Constants
 * 
 * Core constants for the Wealthica v2 API integration.
 */

/**
 * Base URL for Wealthica API v2
 */
// ---
// NOTE: These values are hardcoded due to lovable.dev's lack of frontend env var support.
// Only public config is included here. Secrets remain in Supabase Edge Function secrets.
// If/when frontend env var support is added, migrate these to env vars.
// ---
export const WEALTHICA_API_BASE_V2 = 'https://api.wealthica.com';

/**
 * Wealthica Connect URL for authentication flow
 */
export const WEALTHICA_CONNECT_URL_V2 = 'https://connect.wealthica.com/connect';

/**
 * Default return path after connection flow
 */
export const WEALTHICA_RETURN_PATH = '/investments';

/**
 * Token endpoint for authentication
 */
export const WEALTHICA_TOKEN_ENDPOINT_V2 = `${WEALTHICA_API_BASE_V2}/auth/token`;

/**
 * Default client ID for Wealthica integration
 * 
 * @security This value is public and can be included in client-side code
 */
export const WEALTHICA_CLIENT_ID_V2 = '25qbe9pl8fe8a2mdah94j3026m';

/**
 * Connection status enum for Wealthica connections
 */
export enum WealthicaConnectionStatus {
  IDLE = 'idle',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  LOADING_ACCOUNTS = 'loading_accounts',
  DISCONNECTED = 'disconnected',
  ERROR = 'error',
  PENDING = 'pending'
}

/**
 * Storage keys for Wealthica v2 integration
 */
export enum WEALTHICA_STORAGE_KEYS {
  AUTH_STATE = 'WEALTHICA_AUTH_STATE',
  RETURN_PATH = 'WEALTHICA_RETURN_PATH',
  CONNECTION_DATA = 'WEALTHICA_CONNECTION_DATA',
  BEARER_TOKEN = 'WEALTHICA_BEARER_TOKEN',
  CONNECTION_CONFIRMED = 'WEALTHICA_CONNECTION_CONFIRMED',
};

/**
 * Error types for Wealthica integration
 * Used for consistent error handling across the application
 */
export enum WealthicaErrorType {
  API_ERROR = 'api_error',
  TOKEN_ERROR = 'token_error',
  RATE_LIMIT_EXCEEDED = 'rate_limit_exceeded',
  UNKNOWN_ERROR = 'unknown_error',
  CONNECTION_ERROR = 'connection_error',
  INVALID_RESPONSE = 'invalid_response'
};
